module.exports = __webpack_public_path__ + "static/media/RestaurantPassport.9b599a3e.png";